// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f278ecf","453":"aa9cb600","455":"ed27270e","977":"4816cce7"}[chunkId] + ".chunk.js";
};